module.exports = __webpack_public_path__ + "img/add-debit-card.7fbcc493.jpg";